import { render, staticRenderFns } from "./journal.vue?vue&type=template&id=1947e175"
import script from "./journal.vue?vue&type=script&lang=js"
export * from "./journal.vue?vue&type=script&lang=js"
import style0 from "./journal.vue?vue&type=style&index=0&id=1947e175&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports